// Brave Search Service - Web Search Integration
// API Key: BSAhzuEEMN42CCDIrVoOrVRDztR9inb
// Free tier: 2,000 requests/month

const BRAVE_API_KEY = 'BSAhzuEEMN42CCDIrVoOrVRDztR9inb';
const BRAVE_BASE_URL = 'https://api.search.brave.com/res/v1/web/search';

class BraveSearchService {
  /**
   * Perform web search
   */
  async search(query, options = {}) {
    try {
      const params = new URLSearchParams({
        q: query,
        count: options.count || 10,
        offset: options.offset || 0,
        safesearch: options.safesearch || 'moderate',
        freshness: options.freshness || '', // pd (past day), pw (past week), pm (past month), py (past year)
        text_decorations: options.textDecorations !== false,
        spellcheck: options.spellcheck !== false
      });

      const response = await fetch(`${BRAVE_BASE_URL}?${params}`, {
        headers: {
          'Accept': 'application/json',
          'Accept-Encoding': 'gzip',
          'X-Subscription-Token': BRAVE_API_KEY
        }
      });

      if (!response.ok) {
        throw new Error(`Brave Search API error: ${response.status}`);
      }

      const data = await response.json();

      return {
        success: true,
        query: data.query?.original || query,
        results: this.formatResults(data),
        totalResults: data.web?.results?.length || 0
      };

    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Format search results for display
   */
  formatResults(data) {
    if (!data.web || !data.web.results) {
      return [];
    }

    return data.web.results.map(result => ({
      title: result.title,
      url: result.url,
      description: result.description,
      age: result.age,
      language: result.language,
      familyFriendly: result.family_friendly
    }));
  }

  /**
   * Search for news (recent results)
   */
  async searchNews(query, count = 5) {
    return await this.search(query, {
      count,
      freshness: 'pw', // past week
      safesearch: 'moderate'
    });
  }

  /**
   * Search for recent crypto news
   */
  async searchCryptoNews(symbol, count = 5) {
    const query = `${symbol} cryptocurrency news`;
    return await this.searchNews(query, count);
  }
}

const braveSearchService = new BraveSearchService();
export default braveSearchService;
